export const enumPermisosParametrizacionDatafono = Object.freeze({
  PARAMETRIZACION_DATAFONO: 1001
});

